export default __webpack_public_path__ + "media/images/brands/demo/services/service-04-54b598d6e9a29a33b0093144439b43a5.jpg";